import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

export interface DashboardVendaInternaRequest {
  userId: number;
  dataInicio: string;
  dataFim: string;
  tipoDados: string;
}

export interface DashboardVendaInternaDia {
  dia: string;
  comVenda: number;
  semVenda: number;
  pedidos: number;
  vendasReais: number;
  litros: number;
  total: number;
  efetividade: number;
  conversao: number;
}

export interface DashboardVendaInternaGrupo {
  descricao: string;
  quantidade: number;
  percentual: number;
}

export interface DashboardVendaInternaLigacao {
  idVisita: number;
  sellerIdInterna: number;
  vendInterna: string;
  vendExterno: string;
  tipo: string;
  origem?: string;
  status: string;
  dataLigacao: string;
  codigoErpCliente: string;
  cliente: string;
  cidade: string;
  checkIn: string;
  checkOut: string;
  duracao: number;
  resultado: string;
  observacao: string;
}

export interface DashboardVendaInternaFaturamento {
  sellerIdInterna: number;
  vendInterna: string;
  ligacoes: number;
  vendasReais: number;
  litros: number;
  pedidos: number;
}

export interface DashboardVendaInternaVendedorExterno {
  sellerIdInterna: number;
  vendInterna: string;
  sellerIdExterno: number;
  vendExterno: string;
  ligacoes: number;
  vendasReais: number;
  litros: number;
  pedidos: number;
}

export interface DashboardVendaInternaTipoInterna {
  sellerIdInterna: number;
  vendInterna: string;
  tipo: string;
  vendas: number;
  vendasReais: number;
  litros: number;
  naoVendas: number;
}

export interface DashboardVendaInternaCliente {
  clienteId: number;
  cliente: string;
  cidade: string;
  ligacoes: number;
  vendasReais: number;
  litros: number;
  pedidos: number;
}

export interface DashboardVendaInternaResumo {
  segmentos: DashboardVendaInternaSegmento[];
  dias: DashboardVendaInternaDia[];
  tipos: DashboardVendaInternaGrupo[];
  resultados: DashboardVendaInternaGrupo[];
  ligacoes: DashboardVendaInternaLigacao[];
  faturamentoInterno: DashboardVendaInternaFaturamento[];
  vendedoresExternos: DashboardVendaInternaVendedorExterno[];
  tiposPorInterna: DashboardVendaInternaTipoInterna[];
  clientes: DashboardVendaInternaCliente[];
}

export interface DashboardVendaInternaSegmento {
  segmento: string;
  sellerIdInterna: number;
  vendInterna: string;
  atendimentos: number;
  agendado: number;
  gerado: number;
  manual: number;
  vendasReais: number;
  pedidos: number;
  ticketMedio: number;
  efetividade: number;
}

@Injectable({ providedIn: 'root' })
export class DashboardVendaInternaService {
  constructor(
    private http: HttpClient,
    @Inject('BASE_URL') private baseUrl: string,
    private toastr: ToastrService
  ) { }

  public getResumo(payload: DashboardVendaInternaRequest): Observable<DashboardVendaInternaResumo> {
    return this.http
      .post<DashboardVendaInternaResumo>(this.baseUrl + 'api/DashboardVendaInterna/GetResumo', payload)
      .pipe(
        catchError(() => {
          this.toastr.error('', 'Erro ao carregar Dashboard Venda Interna. Contate o suporte...');
          return of({ segmentos: [], dias: [], tipos: [], resultados: [], ligacoes: [], faturamentoInterno: [], vendedoresExternos: [], tiposPorInterna: [], clientes: [] });
        })
      );
  }
}
